import { addSideEffects } from '@poa/state';
import {
  calculateStat,
  contactGiftsById,
  fetchDaemons,
  syncAccounts,
  syncAccountsAll,
  syncContactGiftsAll,
  syncDaemons,
  syncDaemonsByTime,
  syncMessages,
  syncMessagesAll,
  syncStats,
  syncStatsAll,
  sendHotList
} from './daemons.actions';

addSideEffects(fetchDaemons, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.fetchDaemons();

    const daemons = Object.keys(response)
      .filter(daemonId => daemonId !== 'sync')
      .map(daemonId => ({ daemonId, ...response[daemonId] }));

    actions.daemonsActions.fetchDaemonsSuccess(daemons, response['sync']);
  } catch (e) {
    console.error(e);
    actions.daemonsActions.fetchDaemonsFailed();
    throw e;
  }
});

addSideEffects(sendHotList, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.sendHotList(payload.daemonId);

    if (response.status === 'ok') {
      env.alert('Success', `Daemon ${payload.daemonId} start sending hotLists/smiles`, 'success');
    } else {
      env.alert(
        'Info',
        `Daemon ${payload.daemonId} returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sending hotLists/smiles by daemon ${payload.daemonId} failed`, 'error');
    throw e;
  }
});

addSideEffects(syncAccounts, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.syncAccounts(payload.daemonId);

    if (response.status === 'ok') {
      env.alert(
        'Success',
        `Sync accounts for daemon by id ${payload.daemonId} succeded`,
        'success'
      );
    } else {
      env.alert(
        'Info',
        `Sync accounts for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync accounts for daemon by id ${payload.daemonId} failed`, 'error');
    throw e;
  }
});

addSideEffects(syncStats, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.syncStats(payload.daemonId);

    if (response.status === 'ok') {
      env.alert('Success', `Sync stats for daemon by id ${payload.daemonId} succeded`, 'success');
    } else {
      env.alert(
        'Info',
        `Sync stats for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync status for daemon by id ${payload.daemonId} failed`, 'error');
    throw e;
  }
});

addSideEffects(syncMessages, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.syncMessages(payload.daemonId);

    if (response.status === 'ok') {
      env.alert(
        'Success',
        `Sync messages for daemon by id ${payload.daemonId} succeded`,
        'success'
      );
    } else {
      env.alert(
        'Info',
        `Sync messages for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync messages for daemon by id ${payload.daemonId} failed`, 'error');
    throw e;
  }
});

addSideEffects(contactGiftsById, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.contactGiftsById(payload.daemonId);

    if (response.status === 'ok') {
      env.alert(
        'Success',
        `Sync contact/gifts for daemon by id ${payload.daemonId} succeded`,
        'success'
      );
    } else {
      env.alert(
        'Info',
        `Sync contact/gifts for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync contact/gifts for daemon by id ${payload.daemonId} failed`, 'error');
    throw e;
  }
});

addSideEffects(syncContactGiftsAll, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.syncContactGiftsAll();

    if (response.status === 'ok') {
      env.alert('Success', `Sync contact/gifts succeess`, 'success');
    } else {
      env.alert('Info', `Sync contact/gifts failed`, 'info');
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync contact/gifts all failed`, 'error');
    throw e;
  }
});

addSideEffects(calculateStat, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.calculateStat();

    if (response.status === 'ok') {
      env.alert('Success', 'Calculation in progress', 'success');
    } else {
      env.alert('Info', `Calculation started with success status code but ${response}`, 'info');
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', 'Calculation failed', 'error');
    throw e;
  }
});

addSideEffects(syncDaemons, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.syncDaemons();

    if (response.status === 'ok') {
      env.alert('Success', 'Syncing daemons succeded', 'success');
    } else {
      env.alert('Info', `Syncing daemons returned success status code but ${response}`, 'info');
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', 'Syncing daemons failed', 'error');
    throw e;
  }
});

addSideEffects(syncDaemonsByTime, async (payload, { actions, env }) => {
  try {
    const response = await env.api.daemons.syncDaemonsByTime(payload.year, payload.month);

    if (response.status === 'ok') {
      env.alert('Success', 'Syncing daemons by year and month succeded', 'success');
    } else {
      env.alert(
        'Info',
        `Syncing daemons year and month returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', 'Syncing daemons year and month failed', 'error');
    throw e;
  }
});

addSideEffects(syncAccountsAll, async (payload, { env }) => {
  try {
    const response = await env.api.daemons.syncAccountsAll();

    if (response.status === 'ok') {
      env.alert('Success', `Sync all accounts succeded`, 'success');
    } else {
      env.alert(
        'Info',
        `Sync accounts for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync all accounts failed`, 'error');
    throw e;
  }
});

addSideEffects(syncMessagesAll, async (payload, { env }) => {
  try {
    const response = await env.api.daemons.syncMessagesAll();

    if (response.status === 'ok') {
      env.alert('Success', `Sync all messages succeded`, 'success');
    } else {
      env.alert(
        'Info',
        `Sync messages for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync all messages failed`, 'error');
    throw e;
  }
});

addSideEffects(syncStatsAll, async (payload, { env }) => {
  try {
    const response = await env.api.daemons.syncStatsAll();

    if (response.status === 'ok') {
      env.alert('Success', `Sync all stats succeded`, 'success');
    } else {
      env.alert(
        'Info',
        `Sync stats for daemon by id ${
          payload.daemonId
        } returned success status code but ${response}`,
        'info'
      );
    }
  } catch (e) {
    console.error(e);
    env.alert('Error', `Sync all messages failed`, 'error');
    throw e;
  }
});
